import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import IconDiscard from '../../../../../components/icons/icon-discard/icon-discard';
import { ButtonIcon } from '../../../../../components/inputs/button-icon/button-icon';

interface TagProps {
    text: string;
    onClose?: () => void;
}

const ShipmentsPageFilterTag: React.FC<TagProps> = ({ text, onClose }) => {
    return (
        <div className="tag">
            <FontBody2>{text}</FontBody2>
            <ButtonIcon onClick={onClose} color='var(--color-neutral-3)' Component={IconDiscard}/>
        </div>
    );
};

export default ShipmentsPageFilterTag;